define('drops/bucketDrop/bucketDrop',[
    'jquery',
    'underscore',
    'lq',
    'lq/style',
    'lq/drop',
    'lq/responsive'
], function (
    $,
    _,
    main,
    Style,
    Drop,
    responsive) {
    'use strict';

    function BucketDrop(options) {
        Drop.call(this, $('<div class="canvas-target" />'), options);

        this.$element.css({
            'overflow-y': 'auto',
            'overflow-x': 'hidden'
        });

        Style.renderStyles(this, null, this.$element);

        //this.data.url = 'http://localhost:25000';
    }

    Drop.extend(BucketDrop, Drop);

    BucketDrop.typeName = 'BucketDrop';

    BucketDrop.prototype.preRender = function () {
        this.applyPosition();
    };

    BucketDrop.prototype.postRender = function () {
        var baseUrl = (this.data.url || main.getTenantUploads('Buckets')) + '/';

        var self = this;
        $.get(baseUrl + this.data.definition + requirejs.s.contexts._.config.urlArgs(null, ''), function (bucketInfo) {
            _.each(bucketInfo.files.stylesheets, function (stylesheet) {
                var el = document.createElement('link');
                el.setAttribute('rel', 'stylesheet');
                el.setAttribute('type', 'text/css');
                el.setAttribute('href', baseUrl + stylesheet + requirejs.s.contexts._.config.urlArgs(null, ''));
                document.getElementsByTagName('head')[0].appendChild(el);
            });

            var loadedCount = bucketInfo.files.scripts.length;
            _.each(bucketInfo.files.scripts, function (file) {
                var script = document.createElement('script');
                script.async = false; // make sure the script are executed in the correct order
                script.setAttribute('type', 'text/javascript');
                script.setAttribute('src', baseUrl + file + requirejs.s.contexts._.config.urlArgs(null, ''));
                script.onload = function () {
                    if (loadedCount === 1) {
                        window[bucketInfo.id].default({
                            id: self.data.id,
                            bucketsBaseUrl: baseUrl,
                            configuration: self.data.configuration,
                            targetElement: self.$element.get(0),
                            piping: self.piping,
                            triggerEvent: self.triggerEventIfEnabled.bind(self),
                            deviceType: responsive.getDeviceType().name,
                            url: {
                                runtime: main.getTenantUrl(''),
                                uploads: main.getTenantUploads(''),
                                root: main.getBaseUrl('')
                            }
                        });

                        _.each(bucketInfo.methods, function (method) {
                            self['licquidMethod_' + method.name] = self.callMethodOnBucket.bind(self, bucketInfo.id, method.name);
                        });
                    } else {
                        loadedCount--;
                    }
                };
                document.getElementsByTagName('head')[0].appendChild(script);
            });
        });
    };

    BucketDrop.prototype.callMethodOnBucket = function (bucketId, methodName, args) {
        window[bucketId][methodName](args);
    };

    return BucketDrop;
});
